import { css } from 'styled-components';
import { darken } from 'polished';

export default css`
  box-sizing: border-box;
  width: 100%;
  display: block;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.grayLightColor};
  padding: .75rem 1rem;
  text-align: left;
  outline-color: blue;

  &:disabled {
    background-color: ${darken(0.06, 'white')};
    opacity: .9;
    cursor: not-allowed;
  }
`;
